import { render, staticRenderFns } from "./videoTxtAd.vue?vue&type=template&id=2c84f9a2&scoped=true&"
import script from "./videoTxtAd.vue?vue&type=script&lang=js&"
export * from "./videoTxtAd.vue?vue&type=script&lang=js&"
import style0 from "./videoTxtAd.vue?vue&type=style&index=0&id=2c84f9a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_css-loader@3.6.0_webpack@5.90.3__handlebars@4.7.8_lodash@4.17.21_vue_81019702941bc64194e0b334b51761b2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84f9a2",
  null
  
)

export default component.exports